import React from 'react';
import {
  ShieldExclamationIcon,
  SparklesIcon,
} from '@heroicons/react/24/outline';

const ShieldExclamation = ShieldExclamationIcon as any;
const Sparkles = SparklesIcon as any;

export const AccessDenied: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-pink-50 dark:from-gray-900 dark:via-purple-900 dark:to-violet-900 flex items-center justify-center p-4" dir="rtl">
      <div className="text-center p-6 sm:p-8 md:p-12 max-w-xs sm:max-w-sm md:max-w-md mx-auto">
        <div className="relative mx-auto mb-6 sm:mb-8">
          <div className="absolute inset-0 bg-gradient-to-r from-red-400 to-pink-400 rounded-full opacity-20"></div>
          <div className="relative flex items-center justify-center h-16 w-16 sm:h-20 sm:w-20 md:h-24 md:w-24 mx-auto rounded-full bg-gradient-to-r from-red-400 to-pink-400 shadow-xl">
            <ShieldExclamation className="h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 text-white" />
          </div>
        </div>
        <h2 className="text-xl sm:text-2xl md:text-3xl font-bold bg-gradient-to-r from-red-600 to-pink-600 bg-clip-text text-transparent mb-3 sm:mb-4 break-words leading-tight">
          دسترسی محدود
        </h2>
        <p className="text-gray-600 dark:text-gray-300 text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8 break-words">
          شما مجوز دسترسی به این بخش را ندارید.
        </p>
        <a
          href="/dashboard"
          className="inline-flex items-center px-4 py-2 sm:px-6 sm:py-3 bg-gradient-to-r from-violet-500 to-purple-500 text-white font-medium rounded-xl hover:from-violet-600 hover:to-purple-600 transform hover:scale-105 shadow-lg hover:shadow-xl text-sm sm:text-base"
        >
          <Sparkles className="h-4 w-4 sm:h-5 sm:w-5 ml-1 sm:ml-2 flex-shrink-0" />
          <span className="break-words">بازگشت به داشبورد</span>
        </a>
      </div>
    </div>
  );
};
